/*
  Softech Store - licence type and licence term as buttons with the price on each term
  (Batch 5 item 2, A204, Najam 2 Oct 2026). Markup: snippets/softech-term-picker.liquid.

  Works only from the product's own data. Nothing is invented:
    - "type" option  = an option whose values are New / Renewal (both present);
    - "term" option  = an option named Tenure / Term / Duration / Period with two or more values
      ("1 MOS", "12 MOS", "24 MOS", "36 MOS", "1-year", "3-year", "5-year", "unlimited", "-").
  A product with neither keeps the theme's standard dropdowns and this script does nothing.

  The buttons drive the theme's own dropdowns (value + change event), so the variant, price,
  SKU, stock state and the A176 quantity bands update exactly as when the dropdown is used.
  The price on a term button is the price of the variant that term gives with the other
  options as they are selected now.

  Pure functions are exported for node tests (module.exports).
*/
(function (root) {
  'use strict';

  // "12 MOS" -> {months: 12, label: "1 year"}; "3-year" -> {months: 36, label: "3 years"}
  function parseTerm(value) {
    var s = String(value == null ? '' : value).trim();
    var m = s.match(/^(\d+)\s*(?:mos?|months?)\.?$/i);
    if (m) return termOf(parseInt(m[1], 10));
    m = s.match(/^(\d+)[\s-]*(?:years?|yrs?)$/i);
    if (m) return termOf(parseInt(m[1], 10) * 12);
    if (/^unlimited$/i.test(s) || /^perpetual$/i.test(s)) return { months: Infinity, label: 'Unlimited' };
    if (s === '-' || s === '') return { months: 0, label: 'No term' };
    return null;
  }

  function termOf(months) {
    if (!(months > 0)) return null;
    if (months % 12 === 0) { var y = months / 12; return { months: months, label: y + (y === 1 ? ' year' : ' years') }; }
    return { months: months, label: months + (months === 1 ? ' month' : ' months') };
  }

  function distinct(variants, i) {
    var seen = {}, out = [];
    variants.forEach(function (v) { var x = v.options[i]; if (x != null && !seen[x]) { seen[x] = 1; out.push(x); } });
    return out;
  }

  function isNew(v) { return /^new\b/i.test(String(v).trim()); }
  function isRenewal(v) { return /^renew/i.test(String(v).trim()); }

  // -> {typeIndex, termIndex} (each -1 when the product has no such option), or null when neither.
  function analyse(data) {
    var names = data.options || [], variants = data.variants || [];
    var typeIndex = -1, termIndex = -1;
    for (var i = 0; i < names.length; i++) {
      var vals = distinct(variants, i);
      if (typeIndex < 0 && vals.length >= 2 && vals.every(function (x) { return isNew(x) || isRenewal(x); }) &&
          vals.some(isNew) && vals.some(isRenewal)) { typeIndex = i; continue; }
      if (termIndex < 0 && /tenure|term|duration|period/i.test(names[i]) && vals.length >= 2 &&
          vals.every(function (x) { return !!parseTerm(x); })) termIndex = i;
    }
    if (typeIndex < 0 && termIndex < 0) return null;
    return { typeIndex: typeIndex, termIndex: termIndex, names: names, variants: variants,
             moneyFormat: data.money_format || '${{amount}}' };
  }

  // The variant for a selection (array of option values, in option order), or null.
  function variantFor(model, selected) {
    for (var k = 0; k < model.variants.length; k++) {
      var v = model.variants[k], ok = true;
      for (var i = 0; i < v.options.length; i++) if (v.options[i] !== selected[i]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }

  // Buttons of one option for the current selection: every value of the option, with the variant
  // it would give (null when that combination is not sold).
  function choicesFor(model, index, selected) {
    var out = distinct(model.variants, index).map(function (value) {
      var sel = selected.slice(); sel[index] = value;
      return { value: value, variant: variantFor(model, sel), active: selected[index] === value };
    });
    if (index === model.termIndex) {
      out.forEach(function (c) { c.term = parseTerm(c.value); });
      out.sort(function (a, b) { return a.term.months - b.term.months; });
    }
    return out;
  }

  function typeLabel(value) { return isRenewal(value) ? 'Renewal' : 'New licence'; }

  function formatMoney(cents, format) {
    if (root.SoftechBands && root.SoftechBands.formatMoney) return root.SoftechBands.formatMoney(cents, format);
    cents = Math.round(Number(cents) || 0);
    var s = (Math.abs(cents) / 100).toFixed(2).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (cents < 0 ? '-' : '') + '$' + s.join('.');
  }

  // Second line of a term button: the same price per year, for terms longer than a year.
  function perYear(choice, format) {
    if (!choice.variant || !choice.term) return '';
    var m = choice.term.months;
    if (!isFinite(m) || m <= 12 || m % 12 !== 0) return '';
    return formatMoney(Math.round(choice.variant.price / (m / 12)), format) + ' per year';
  }

  var api = { parseTerm: parseTerm, analyse: analyse, variantFor: variantFor, choicesFor: choicesFor,
              typeLabel: typeLabel, perYear: perYear, formatMoney: formatMoney };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.SoftechTerm = api;
  if (typeof document === 'undefined') return;

  // ------------------------------------------------------------------ DOM part
  function start(box) {
    if (box.dataset.sltReady) return;
    var data;
    try { data = JSON.parse(box.querySelector('[data-slt-data]').textContent); } catch (e) { return; }
    var model = analyse(data);
    if (!model) return;
    var info = box.closest('product-info');
    var sid = info && info.dataset.section;
    if (!sid) return;
    box.dataset.sltReady = '1';

    function selects() { return document.getElementById('variant-selects-' + sid); }
    function controls() {
      var vs = selects();
      if (!vs) return [];
      return Array.prototype.map.call(vs.querySelectorAll('.product-form__input'), function (wrap) {
        var sel = wrap.querySelector('select');
        if (sel) return { type: 'select', el: sel };
        return { type: 'radio', items: wrap.querySelectorAll('input[type="radio"]') };
      });
    }
    function selected() {
      return controls().map(function (c) {
        if (c.type === 'select') return c.el.value;
        for (var i = 0; i < c.items.length; i++) if (c.items[i].checked) return c.items[i].value;
        return null;
      });
    }
    if (controls().length !== model.names.length) return; // the page is not the standard picker: leave it alone

    // Hide the theme's dropdowns for the options shown as buttons (they stay in the page and keep working;
    // without this script they are simply shown as before).
    var css = [model.typeIndex, model.termIndex].filter(function (i) { return i >= 0; }).map(function (i) {
      return '#variant-selects-' + sid + ' > .product-form__input:nth-child(' + (i + 1) + ')';
    }).join(',') + '{display:none!important}';
    var st = document.createElement('style');
    st.textContent = css;
    box.appendChild(st);

    // Keep the product's own order of choices: when another option comes first in the data
    // ("Select Subscription", "Select Appliance"), the buttons go below the dropdowns.
    var firstIndex = Math.min.apply(null, [model.typeIndex, model.termIndex].filter(function (i) { return i >= 0; }));
    var vs0 = selects();
    if (firstIndex > 0 && vs0 && vs0.parentNode) vs0.parentNode.insertBefore(box, vs0.nextSibling);

    function pick(index, value) {
      var c = controls()[index];
      if (!c) return;
      var target = null;
      if (c.type === 'select') { c.el.value = value; target = c.el; }
      else for (var i = 0; i < c.items.length; i++) if (c.items[i].value === value) { c.items[i].checked = true; target = c.items[i]; }
      if (!target) return;
      // The form posts the right variant at once, before the page finishes redrawing.
      var v = variantFor(model, selected());
      var idIn = document.querySelector('#product-form-' + sid + ' input[name="id"]');
      if (v && idIn) idIn.value = v.id;
      target.dispatchEvent(new Event('change', { bubbles: true }));
      render();
    }

    function group(index, title, kind) {
      var sel = selected();
      var wrap = document.createElement('div');
      wrap.className = 'slt-group slt-group--' + kind;
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', title);
      var h = document.createElement('p');
      h.className = 'slt-title';
      h.textContent = title;
      wrap.appendChild(h);
      var row = document.createElement('div');
      row.className = 'slt-row';
      choicesFor(model, index, sel).forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'slt-pill' + (c.active ? ' is-active' : '');
        b.setAttribute('aria-pressed', c.active ? 'true' : 'false');
        var name = document.createElement('span');
        name.className = 'slt-name';
        name.textContent = kind === 'type' ? typeLabel(c.value) : c.term.label;
        b.appendChild(name);
        if (kind === 'term') {
          var price = document.createElement('span');
          price.className = 'slt-price';
          var per = document.createElement('span');
          per.className = 'slt-per';
          if (!c.variant) { price.textContent = 'Not offered'; b.disabled = true; }
          else {
            price.textContent = formatMoney(c.variant.price, model.moneyFormat);
            per.textContent = c.variant.available === false ? 'Currently unavailable' : perYear(c, model.moneyFormat);
          }
          b.appendChild(price);
          if (per.textContent) b.appendChild(per);
        } else if (!c.variant) { b.disabled = true; }
        b.addEventListener('click', function () { if (!c.active) pick(index, c.value); });
        row.appendChild(b);
      });
      wrap.appendChild(row);
      if (kind === 'term' && row.querySelector('.slt-pill[disabled]')) {
        var miss = document.createElement('p');
        miss.className = 'slt-note';
        miss.textContent = 'A term marked "Not offered" is not sold with the current selection.';
        wrap.appendChild(miss);
      }
      return wrap;
    }

    var out = box.querySelector('[data-slt-out]');
    function render() {
      if (controls().length !== model.names.length) return;
      var frag = document.createDocumentFragment();
      if (model.typeIndex >= 0) frag.appendChild(group(model.typeIndex, 'Licence type', 'type'));
      if (model.termIndex >= 0) frag.appendChild(group(model.termIndex, 'Licence term', 'term'));
      out.textContent = '';
      out.appendChild(frag);
      box.hidden = false;
    }
    render();

    // Redraw after any option change and after the theme has redrawn the product.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('#variant-selects-' + sid)) { render(); return; }
      if (t.name === 'id' && t.closest('#product-form-' + sid)) setTimeout(render, 0);
    });
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-slt]'), start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})(typeof window !== 'undefined' ? window : this);
